import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  private errorSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  public setErrorMessage(error: string[]): void {
    const errorMessage = error.length > 0 ? error.filter(err => !!err) : ['Internal server error, please try again later'];
    this.errorSubject.next(errorMessage);
  }

  public getErrorMessage(): Observable<string[]> {
    return this.errorSubject.asObservable();
  }

  public clearErrorMessage(): void {
    this.errorSubject.next([]);
  }
}